import { useContext, useEffect, useState } from "react";
import { UBAppModal } from "../../../../Libraries";
import styles from "./styles.module.css";
import { LanguageContext } from "../../../../context/LanguageContext";
import TabAutoComplete from "../../../../Libraries/TabAutoComplete";
import { ExpenseCategoryList } from "../../../../constants";
import withObservables from "@nozbe/with-observables";
import { of } from "rxjs";
import { analytics, triggerLogEvent } from "../../../../config/firebase";
import { Box } from "@mui/material";
import { getCategoriesByType, resolveCategoryDisplayName } from "../../../../utils";

const ChangeCategoryModal = ({
  open,
  onClose,
  onConfirm,
  type,
  loading,
  value,
}) => {
  const [categoryList, setCategoryList] = useState([]);
  const [category, setCategory] = useState(value || "");
  const categoryGroup =
    type?.toLowerCase() == "sale" ? "business_sale" : "business_expense";
  const [categoryLabel, setCategoryLabel] = useState(
    resolveCategoryDisplayName(categoryGroup, value) || "",
  );

  useEffect(() => {
    setCategoryList(getCategoriesByType(categoryGroup));
  }, [categoryGroup]);

  const [I18n] = useContext(LanguageContext);
  return (
    <UBAppModal
      id="change_category_modal"
      open={open}
      header={{
        title: "change_category",
        handleClose: onClose,
        dont_show_cross_icon: true,
      }}
      className={`${styles.changeCategoryModal} changeCategoryModal`}
      footer={[
        {
          data: {
            className: "ubSecondaryButton",
            title: I18n.cancel,
            onClick: onClose,
            id: `ChangeCategoryModal_cancel`,
          },
        },
        {
          data: {
            className: "ubPrimaryButton fontSize12 fontWeight400 bgPrimary",
            title: I18n.save,
            onClick: () => onConfirm(category),
            disabled: !Boolean(category) || loading,
            loading,
            id: `ChangeCategoryModal_confirm`,
          },
        },
      ]}
    >
      <Box>
        <TabAutoComplete
          className={styles.dropdownContainer}
          id={"ChangeCategoryModal_category"}
          list={categoryList}
          label={type == "sale" ? I18n.sales_category : I18n.expense_category}
          handleSelect={(item) => {
            setCategory(item?.id || "");
            setCategoryLabel(item?.label || "");
          }}
          value={categoryLabel}
          placeholder={
            type == "sale"
              ? I18n.select_sales_category
              : I18n.select_expense_category
          }
          handleStartLogEvent={() =>
            triggerLogEvent(analytics, "change_category")
          }
        />
      </Box>
    </UBAppModal>
  );
};

export default ChangeCategoryModal;
